class CheckSubscription {
    constructor() {
        this.emailField = document.querySelector("#input_2_3");
        console.log("CheckSubscription initialized", this.emailField);
        this.init();
    }

    init() {
        if (this.emailField) {
            this.emailField.addEventListener('blur', (e) => this.handleBlur(e));
            console.log("Event listener added");
        } else {
            console.log("Email field not found");
        }
    }

    handleBlur(e) {
        const email = this.emailField.value;
        console.log("Blur event detected, email:", email);

        if (typeof ajax_object !== 'undefined') {
            jQuery.ajax({
                type: 'POST',
                url: ajax_object.ajax_url,
                data: {
                    action: 'check_subscription_email',
                    email: email
                },
                success: (response) => this.handleResponse(response)
            });
        } else {
            console.error("ajax_object is not defined");
        }
    }

    handleResponse(response) {
        const data = JSON.parse(response);
        console.log("AJAX response received", data);
        if (data.status === 'subscribed') {
            this.showMessage(data.message);
        }
    }

    showMessage(message) {
        // 기존 메시지 요소가 있다면 제거
        const existingMessage = document.getElementById('subscription-message');
        if (existingMessage) {
            existingMessage.remove();
        }

        // 새로운 메시지 요소 생성
        const messageElement = document.createElement('div');
        messageElement.id = 'subscription-message';
        messageElement.innerHTML = message;

        // 이메일 필드 아래에 메시지 추가
        this.emailField.parentNode.appendChild(messageElement);
    }
}

export default CheckSubscription;